//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "source-sup-list",
  data(){
    return{
      sourceDto:{},
      sourceId:null
    }
  },
  methods:{
    goBackLast(){
      this.$router.go(-1);
    },
    getSourceDto(){
      this.$loadingShow();
      this.$get(`api/source/${this.sourceId}`).then((res) => {
        if(res){
          this.sourceDto = res;
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    changeShow(data){
      if(data.cellShow){
        this.$set(data,'cellShow',false);
        return;
      }
      this.$set(data,'cellShow',true);
    },
    changeSelected(data,str){
      this.$set(data,'selectShow',str);
    },
    approval(){
      this.$vux.toast.text('请前往pc端进行审核');
    }
  },
  mounted(){
    this.sourceId = this.$route.params.id;
    this.getSourceDto();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-item/source-sup-list.vue